// extracted by mini-css-extract-plugin
export default {"summary-container":"FrequencySlabReportSummary_summary-container__Szee6","summary-ctas":"FrequencySlabReportSummary_summary-ctas__S3B3N"};